export default {"src":"/_next/static/media/icon_flag_cn.28d66156.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};